import { createFileRoute } from '@tanstack/react-router';
import { routeContracts } from '@/app/router/routeContracts';

/**
 * Catch-all route pro neznámé frontendové cesty.
 * Zobrazuje frontendovou 404 stránku uvnitř SPA shellu.
 *
 * Tato route nepřebíjí backend prefixy (/api, /health, /scalar, /openapi),
 * protože ty jsou obsluhovány backendem ještě před tím, než se dostane k SPA.
 * Tenký wrapper – komponenta vlastněna not-found slicem.
 */
export const Route = createFileRoute('/$')({
  component: routeContracts.notFound.component,
});
